var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-0 mr-0",attrs:{"color":"primary","text":!_vm.value},on:{"click":_vm.toggle}},[_vm._v(" Tous les lots ")])
}
var staticRenderFns = []

export { render, staticRenderFns }